<script setup>
import { computed, inject } from 'vue'
import Step from './step.vue'
import ReplyItem from './coordination_replyItem.vue'
import Stickypanel from '@provise/components/stickypanel.vue'
import { REPLY_STATES } from '../item.vue'
import { useUserStore } from '@provise/stores/user.js'

const props = defineProps({
  edit: Boolean,
  editPermission: {
    type: Boolean,
    default: true,
  },
})
const userStore = useUserStore()
defineEmits(['save', 'refresh'])
const model = defineModel()
const [replies] = inject('replies')

const aligningReplies = computed(() => {
  return replies.value.filter(r => r.assign_role != null)
})

const currUser = computed(() => {
  return model.value.sla_users?.coordination || null
})

const coordEditPermission = computed(() => {
  return props.editPermission && userStore.can(model.value.assign_role?.name)
})
</script>
<template>
  <Step v-model="model" :edit="edit">
    <template #plain v-if="replies.length">
      <dl class="grid mb-0" style="row-gap: 0">
        <template v-for="reply of replies" :key="reply.id">
          <dt class="g-col-3">Файл:</dt>
          <dd class="g-col-9 mb-0 hstack gap-2">
            <a download :href="reply.link" v-if="reply.link">{{ reply.display_name }}</a>
            <span v-else>{{ reply.display_name }}</span>
            <span
              class="text-success fs-6 fw-bold"
              v-if="reply.get_state === REPLY_STATES.STATE_DONE"
              >Согласован</span
            >
            <span
              class="text-warning fs-6 fw-bold"
              v-if="reply.get_state === REPLY_STATES.STATE_WAIT"
              >Ожидает согласования</span
            >
            <span
              class="text-warning fs-6 fw-bold"
              v-if="reply.get_state === REPLY_STATES.STATE_WAIT_COMMERCE"
              >Ожидает согласования коммерческим отделом</span
            >
            <span
              class="text-danger fs-6 fw-bold"
              v-if="reply.get_state === REPLY_STATES.STATE_DENY"
              >На доработке</span
            >
          </dd>
          <template v-if="reply.comment">
            <dt class="g-col-3">Комментарий:</dt>
            <dd class="g-col-9">{{ reply.comment }}</dd>
          </template>
          <template v-if="reply.approval_comment_label">
            <dt class="g-col-3">Замечание:</dt>
            <dd class="g-col-9" v-html="reply.approval_comment_label" />
          </template>
        </template>
      </dl>
    </template>
    <div class="vstack gap-3 mb-3">
      <ReplyItem
        v-for="reply of aligningReplies"
        :key="reply.id"
        :model-value="reply"
        :disabled="!currUser || !editPermission"
      />
    </div>

    <div class="hstack gap-2 flex-wrap" v-if="!currUser && coordEditPermission">
      <button type="button" class="btn btn-outline-success" @click="$emit('save')">
        <x-icon icon="pencil" />
        Взять в работу
      </button>
    </div>
    <div v-if="$slots.sla && currUser && editPermission" class="my-4">
      <slot name="sla" />
    </div>
    <div class="d-grid" v-if="currUser && editPermission">
      <Stickypanel>
        <slot name="form-post-controls" />
      </Stickypanel>
    </div>
    <div v-if="!editPermission" class="alert alert-info">
      Редактирование невозможно. У вас нет прав
    </div>
  </Step>
</template>
